import React from "react";

const TECH_ITEMS = [
  "Go", "Python", "TypeScript", "Node.js", "FastAPI", "React",
  "Next.js", "GraphQL", "gRPC", "Kafka", "Redis", "PostgreSQL",
  "MongoDB", "AWS", "Docker", "Kubernetes", "LangChain", "RAG",
  "Spring Boot", "Terraform", "WebSockets", "DynamoDB",
  "Prometheus", "Solana", "OpenAI", "Pinecone",
];

const MarqueeRow = ({ reverse }) => (
  <div className={`marquee-track ${reverse ? "marquee-reverse" : ""}`}>
    {[...TECH_ITEMS, ...TECH_ITEMS].map((item, i) => (
      <span key={i} className="marquee-item">
        {item}
        <span className="marquee-dot" />
      </span>
    ))}
  </div>
);

const TechMarquee = () => (
  <div className="tech-marquee">
    <MarqueeRow />
    <MarqueeRow reverse />
  </div>
);

export default TechMarquee;
